// @flow

import * as React from 'react';

import type { MediaBatchPhotoSectionManagedProps } from '@ta/social.section-media-batch-photo';

import type { Props as MediaBatchPhotoSectionProps } from './MediaBatchPhotoSection';
import MediaBatchPhotoSection from './MediaBatchPhotoSection';

// Take everything from MediaBatchPhotoSectionProps except the managed props
type Props = $Diff<MediaBatchPhotoSectionProps, MediaBatchPhotoSectionManagedProps>;

const ManagedMediaBatchSection = (props: Props) => {
  const [currentlyDisplayedImageIndex, setCurrentlyDisplayedImageIndex] = React.useState(0);
  return (
    <MediaBatchPhotoSection
      {...props}
      currentlyDisplayedImageIndex={currentlyDisplayedImageIndex}
      setCurrentlyDisplayedImageIndex={setCurrentlyDisplayedImageIndex}
    />
  );
};

export default ManagedMediaBatchSection;
